import {Component, OnInit} from '@angular/core';
import {BsModalRef} from 'ngx-bootstrap/modal';

@Component({
    selector: 'error-modal',
    templateUrl: './error-modal.component.html',
    styleUrls: ['./error-modal.component.scss'],
    standalone: false
})
export class ErrorModal implements OnInit {

  public errorMessage: string;

  constructor(
    public bsModalRef: BsModalRef
  ) {
  }

  ngOnInit() {
    setTimeout(() => {
      this.bsModalRef.hide();
    }, 3000);
  }
}
